import { UserPreferences } from '@/common/type';

export const DEFAULT_TABLE_BORDER_COLOR = '#f0f0f0';
export const TABLE_BORDER_COLOR_PROPERTY = '--sf-table-border-color';
export const TABLE_VERTICAL_BORDER_COLOR_PROPERTY = '--sf-table-vertical-border-color';

const HEX_COLOR_PATTERN = /^#[0-9a-f]{6}$/i;

export function isValidTableBorderColor(value: unknown): value is string {
  return typeof value === 'string' && HEX_COLOR_PATTERN.test(value);
}

export function getTableBorderColor(preferences?: UserPreferences): string {
  const color = preferences?.tableAppearance?.borderColor;
  return isValidTableBorderColor(color) ? color.toLowerCase() : DEFAULT_TABLE_BORDER_COLOR;
}

export function getShowVerticalRowBorders(preferences?: UserPreferences): boolean {
  return preferences?.tableAppearance?.showVerticalRowBorders !== false;
}

export function applyTableAppearancePreference(preferences?: UserPreferences): void {
  if (typeof document === 'undefined') {
    return;
  }

  const color = preferences?.tableAppearance?.borderColor;
  if (isValidTableBorderColor(color)) {
    document.documentElement.style.setProperty(TABLE_BORDER_COLOR_PROPERTY, color.toLowerCase());
  } else {
    document.documentElement.style.removeProperty(TABLE_BORDER_COLOR_PROPERTY);
  }

  if (getShowVerticalRowBorders(preferences)) {
    document.documentElement.style.removeProperty(TABLE_VERTICAL_BORDER_COLOR_PROPERTY);
  } else {
    document.documentElement.style.setProperty(TABLE_VERTICAL_BORDER_COLOR_PROPERTY, 'transparent');
  }
}
